<fa-icon [icon]="icon" size="2x"></fa-icon>
